import React from "react";
import { PrivacyCenterIntegrationVendorDto } from "../../../../common/service/server/dto/PrivacyCenterIntegrationsDto";
import { VendorIntegrationConfigurationCard } from "./VendorIntegrationConfigurationCard";

import "../../../../../sass/components/organisms/vendor/VendorIntegrationConfigurationContainer.scss";

type VendorIntegrationConfigurationCardContainerProps = {
  vendors: PrivacyCenterIntegrationVendorDto[];
  onConnectClick: (vendor: PrivacyCenterIntegrationVendorDto) => void;
  onEditClick: (vendor: PrivacyCenterIntegrationVendorDto) => void;
  loading?: boolean;
};

export const VendorIntegrationConfigurationContainer: React.FC<
  VendorIntegrationConfigurationCardContainerProps
> = ({ vendors, onConnectClick, onEditClick, loading }) => {
  return (
    <div className="flex-container flex--wrap">
      {vendors
        .sort((a, b) => {
          // Group by errored vendors and connected vendors first
          if (a.connectionError !== b.connectionError) {
            return a.connectionError ? -1 : 1;
          }
          if (a.connected !== b.connected) {
            return a.connected ? -1 : 1;
          }

          // Internal sorting by vendorName
          return a.vendorName.localeCompare(b.vendorName);
        })
        .map((v) => (
          <VendorIntegrationConfigurationCard
            vendor={v}
            key={v.vendorId}
            onConnectClick={onConnectClick}
            onEditClick={onEditClick}
            loading={loading}
          />
        ))}
    </div>
  );
};
